module.exports = __webpack_public_path__ + "c.no2.04341533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/c.no2.jpg
// module id = FkGM
// module chunks = 0